import React from "react";

import { Breadcrumbs } from "components";
import { EditSplitProfileProps } from "types";

import { SplitProfileForm } from "../splitProfileForm/index";

import styles from "static/css/table.module.scss";

const EditSplitProfile = ({
	breadcrumb,
	submit,
	splitProfile,
	splitProfileId,
	loading,
	isAgentDataLoading,
	agent,
}: EditSplitProfileProps) => {
	return (
		<div className={styles.wrappPage}>
			<Breadcrumbs pages={breadcrumb} />

			<SplitProfileForm
				splitProfile={splitProfile}
				splitProfileId={splitProfileId}
				submit={submit}
				loading={loading}
				isAgentDataLoading={isAgentDataLoading}
				isEditing={true}
				agent={agent}
			/>
		</div>
	);
};

export { EditSplitProfile };
